var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthernetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H6C4.89543 5 4 5.89543 4 7V23C4 24.1046 4.89543 25 6 25H24C25.1046 25 26 24.1046 26 23V7C26 5.89543 25.1046 5 24 5Z",
    stroke: "#4dd686",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9629 10.95H12.9879V8.83203H17.0379V10.95H19.0629V13.132H23.1129L23.0879 22.132H6.88794V13.132H10.9379L10.9629 10.95Z",
    stroke: "#4dd686",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 20.385C10.32 20.1724 10.1477 20 9.93505 20C9.72242 20 9.55005 20.1724 9.55005 20.385V21.615C9.55005 21.8276 9.72242 22 9.93505 22C10.1477 22 10.32 21.8276 10.32 21.615V20.385Z",
    fill: "#4dd686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.208 20.385C13.208 20.1724 13.0356 20 12.823 20C12.6104 20 12.438 20.1724 12.438 20.385V21.615C12.438 21.8276 12.6104 22 12.823 22C13.0356 22 13.208 21.8276 13.208 21.615V20.385Z",
    fill: "#4dd686"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0959 20.385C16.0959 20.1724 15.9236 20 15.7109 20C15.4983 20 15.3259 20.1724 15.3259 20.385V21.615C15.3259 21.8276 15.4983 22 15.7109 22C15.9236 22 16.0959 21.8276 16.0959 21.615V20.385Z",
    fill: "#4dd686"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9841 20.385C18.9841 20.1724 18.8117 20 18.5991 20C18.3865 20 18.2141 20.1724 18.2141 20.385V21.615C18.2141 21.8276 18.3865 22 18.5991 22C18.8117 22 18.9841 21.8276 18.9841 21.615V20.385Z",
    fill: "#4dd686"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7641 20.385C11.7641 20.1724 11.5918 20 11.3791 20C11.1665 20 10.9941 20.1724 10.9941 20.385V21.615C10.9941 21.8276 11.1665 22 11.3791 22C11.5918 22 11.7641 21.8276 11.7641 21.615V20.385Z",
    fill: "#4dd686"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6521 20.385C14.6521 20.1724 14.4797 20 14.2671 20C14.0545 20 13.8821 20.1724 13.8821 20.385V21.615C13.8821 21.8276 14.0545 22 14.2671 22C14.4797 22 14.6521 21.8276 14.6521 21.615V20.385Z",
    fill: "#4dd686"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 20.385C17.54 20.1724 17.3676 20 17.155 20C16.9424 20 16.77 20.1724 16.77 20.385V21.615C16.77 21.8276 16.9424 22 17.155 22C17.3676 22 17.54 21.8276 17.54 21.615V20.385Z",
    fill: "#4dd686"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.428 20.385C20.428 20.1724 20.2556 20 20.043 20C19.8303 20 19.658 20.1724 19.658 20.385V21.615C19.658 21.8276 19.8303 22 20.043 22C20.2556 22 20.428 21.8276 20.428 21.615V20.385Z",
    fill: "#4dd686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernetIcon);
export default __webpack_public_path__ + "static/media/ethernet-icon.602adedfaa463bb081c6c6b3b13bfa18.svg";
export { ForwardRef as ReactComponent };